import { Injectable } from "@angular/core";
import { LigneContrat } from "../../../../shared/client/contrat/ligne-contrat";
import { ContratService } from "../../../../shared/client/contrat/contrat.service";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LigneContratLingePlatResolver {

    constructor(
        private contratService: ContratService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LigneContrat> {
        let lc =  this.contratService.getLigneContratLP(route.params['article']);
        return lc;
    }

}
